// @flow
import React, { Component } from 'react';
import { Grid } from 'semantic-grab-ui/src';
import 'chartjs-plugin-datalabels';
import { Bar } from '@reactchartjs/react-chart.js';
import _ from 'lodash';
import { calculateYLabelGap } from './utils';
import { abbreviateNumber, numberWithCommas } from 'omega-rtc/utils/metric-utils';

type RecordCount = {
  key: string,
  value: number,
};

type Record = {
  channel: string,
  counts: Array<RecordCount>,
};

type Props = {
  records: Array<Record>,
  channelColorMapping: Object,
};


// MetricsChart is for displaying comms metrics bar chart
export default class MetricsChart extends Component {
  props: Props;

  formatLabel = (key: string) => {
    if (key === 'read') {
      key = 'open';
    }
    return _.capitalize(key);
  };

  render() {
    const { records } = this.props;

    // flattening records into a non-nested list
    const data = [];
    const legends = [];
    _.map(records, record => {
      legends.push(record.channel);
      _.map(record.counts, count => {
        data.push({ ...count, group: record.channel });
      });
    });
    const values = data.map(r => r.value);

    const yLabelGap = calculateYLabelGap(values, 10, 4);

    const chartData = {
      labels: data.map(r => this.formatLabel(r.key)),
      datasets: [
        {
          label: '',
          data: data.map(r => r.value),
          borderWidth: 0,
          backgroundColor: data.map(r => {
            return _.get(this.props.channelColorMapping, r.group, '#707070');
          }),
        },
      ],
    };

    const options = {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              stepSize: yLabelGap,
              callback(label) {
                return abbreviateNumber(Number(label));
              },
              padding: 16,
            },
            gridLines: {
              drawBorder: false,
              color: '#F0EFEF',
              zeroLineColor: '#F0EFEF',
            },
          },
        ],
        xAxes: [
          {
            maxBarThickness: 16,
            gridLines: {
              display: false,
            },
            ticks: {
              padding: 16,
            },
          },
        ],
      },
      legend: {
        display: false,
      },
      layout: {
        padding: {
          top: 20,
        },
      },
      tooltips: {
        callbacks: {
          label(tooltipItem, data) {
            return numberWithCommas(data.datasets[0].data[tooltipItem.index]);
          },
        },
      },
      hover: {
        animationDuration: 0,
      },
      plugins: {
        datalabels: { // for showing labels on top of each bar
          anchor: 'end',
          align: 'top',
          formatter(value) {
            return abbreviateNumber(value);
          },
        },
      },
    };

    return (<div>
      <Grid>
        <Grid.Row columns={legends.length} style={{ marginBottom: 2 }}>
          {
            _.map(legends, legend => {
              return (<Grid.Column style={{ textAlign: 'center' }}>
                {legend}
              </Grid.Column>);
            })
          }
        </Grid.Row>
        <Grid.Row style={{ paddingTop: 0 }}>
          <Bar
            data={chartData}
            options={options}
          />
        </Grid.Row>
      </Grid>
    </div>);
  }
}
